var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _ from 'lodash';
import { getValuesOfEnum } from '@wemogy/reactbase';
import { types } from 'mobx-state-tree';
function resolveAllDependencies(obj, key, initialKey) {
    if (initialKey === void 0) { initialKey = undefined; }
    if (initialKey === key) {
        return [];
    }
    var isInitialCall = initialKey === undefined;
    if (isInitialCall) {
        initialKey = key;
    }
    var values = obj[key];
    if (values === undefined) {
        if (!isInitialCall) {
            return [key];
        }
        return [];
    }
    values = __spreadArray([], __read(values), false);
    var resolvedValues = values.map(function (value) { return resolveAllDependencies(obj, value, initialKey); });
    if (!isInitialCall) {
        resolvedValues.push([key]);
    }
    return _.sortBy(_.uniq(_.flatten(resolvedValues)));
}
var AuthorizationConfigType = types.custom({
    name: 'IAuthorizationConfig',
    fromSnapshot: function (snapshot) {
        var permissionLevels = Object.values(snapshot.permissionLevels);
        permissionLevels.forEach(function (permissionLevel) {
            var permissionDependencyKeys = Object.keys(permissionLevel.permissionDependencies);
            permissionDependencyKeys.forEach(function (permissionDependencyKey) {
                permissionLevel.permissionDependencies[permissionDependencyKey] = resolveAllDependencies(permissionLevel.permissionDependencies, parseInt(permissionDependencyKey.toString()));
            });
            if (permissionLevel.corePermissionDependencies) {
                var permissionEnumValues_1 = getValuesOfEnum(permissionLevel.permissionEnum);
                permissionLevel.corePermissionDependencies.forEach(function (corePermissionDependency) {
                    permissionEnumValues_1.filter(function (x) { return x !== corePermissionDependency; }).forEach(function (permission) {
                        if (permissionLevel.permissionDependencies[permission]) {
                            if (permissionLevel.permissionDependencies[permission].includes(corePermissionDependency)) {
                                return;
                            }
                            permissionLevel.permissionDependencies[permission].push(corePermissionDependency);
                        }
                        else {
                            permissionLevel.permissionDependencies[permission] = [corePermissionDependency];
                        }
                    });
                });
            }
        });
        return snapshot;
    },
    toSnapshot: function (snapshot) {
        return snapshot;
    },
    isTargetType: function (_value) {
        return true;
    },
    getValidationMessage: function (snapshot) {
        if (typeof snapshot === 'object') {
            return "";
        }
        return JSON.stringify(snapshot) + " doesn't look like a valid IAuthorizationConfig";
    }
});
export default AuthorizationConfigType;
//# sourceMappingURL=AuthorizationConfigType.js.map